var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 9,
    fill: "#999999"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00452 11.816V10.808C8.00452 10.544 8.05652 10.308 8.16052 10.1C8.27252 9.884 8.38852 9.716 8.50852 9.596C8.63652 9.476 8.86852 9.28 9.20452 9.008C9.45252 8.808 9.64852 8.548 9.79252 8.228C9.93652 7.908 10.0085 7.576 10.0085 7.232C10.0085 6.832 9.87252 6.536 9.60052 6.344C9.32852 6.144 8.96052 6.044 8.49652 6.044C8.01652 6.044 7.48452 6.144 6.90052 6.344L6.79252 5.528C7.33652 5.288 7.98852 5.168 8.74852 5.168C9.42052 5.168 9.98052 5.34 10.4285 5.684C10.8845 6.028 11.1125 6.536 11.1125 7.208C11.1125 7.696 11.0085 8.128 10.8005 8.504C10.6005 8.88 10.2765 9.252 9.82852 9.62C9.43652 9.948 9.19652 10.18 9.10852 10.316C9.00452 10.484 8.95252 10.672 8.95252 10.88V11.816H8.00452ZM7.90852 13.784V12.608H9.07252V13.784H7.90852Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltip);
export default __webpack_public_path__ + "static/media/tooltip.389e05bbb83b39e9f053cea594ac086e.svg";
export { ForwardRef as ReactComponent };